import { useState, useMemo } from "react";
import { theme } from "../../theme.js";

export default function ToggleSlider({ checked, onChange, label, size = "medium" }) {
  // Define sizes for responsive scaling
  const sizes = useMemo(() => ({
    small: {
      width: 32,
      height: 18,
      dotSize: 12,
      dotOffset: 3,
      dotShift: 14,
    },
    medium: {
      width: 40,
      height: 22,
      dotSize: 14,
      dotOffset: 3,
      dotShift: 18,
    },
    large: {
      width: 50,
      height: 28,
      dotSize: 18,
      dotOffset: 5,
      dotShift: 22,
    },
  }), []);

  const config = sizes[size] || sizes.medium;

  // Slider background and border styles
  const sliderStyle = {
    position: "relative",
    display: "inline-block",
    width: `${config.width}px`,
    height: `${config.height}px`,
    backgroundColor: checked ? theme.colors.light : theme.colors.gray300,
    borderRadius: `${config.height}px`,
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    verticalAlign: "middle",
    border: "none",
    padding: 0,
    margin: 0,
    outline: "none",
  };

  // Dot/circle styles
  const dotStyle = {
    position: "absolute",
    height: `${config.dotSize}px`,
    width: `${config.dotSize}px`,
    left: checked ? `${config.dotOffset + config.dotShift}px` : `${config.dotOffset}px`,
    top: `${(config.height - config.dotSize) / 2}px`,
    backgroundColor: "white",
    borderRadius: "50%",
    transition: "left 0.3s ease",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    pointerEvents: "none",
  };

  const handleClick = () => {
    if (typeof onChange === "function") onChange();
  };

  return (
    <div style={styles.container}>
      {label && <span style={styles.label}>{label}</span>}
      <button
        type="button"
        onClick={handleClick}
        style={sliderStyle}
        aria-label={label || "Toggle slider"}
        aria-pressed={checked}
        role="switch"
      >
        <div style={dotStyle} />
      </button>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: "#374151",
    userSelect: "none",
    cursor: "pointer",
  },
};
